import classNames from 'classnames';
import React from 'react';

import styles from './badge.module.css';

export type BadgeColor = 'gray' | 'green' | 'orange' | 'purple' | 'teal';

interface Props {
    color: BadgeColor;
    label: string;
}

const colorClassNames: Record<BadgeColor, string> = {
    gray: styles.gray,
    green: styles.green,
    orange: styles.orange,
    purple: styles.purple,
    teal: styles.teal
};

export const Badge: React.FunctionComponent<Props> = ({color, label}) => (
    <span className={classNames(styles.badge, colorClassNames[color])}>{label.toUpperCase()}</span>
);
